// prettier-ignore
export const ActionTypes = {
  SHOW_EDIT_DEVIATE_NOTIFY: 'harami/templates/SHOW_EDIT_DEVIATE_NOTIFY',
  CLOSE_EDIT_DEVIATE_NOTIFY: 'harami/templates/CLOSE_EDIT_DEVIATE_NOTIFY',
} as const satisfies { [k: string]: string}
